export default function mainAddr() {
  return "https://gql.cc.star-horizon.com";
}
